import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CREDENCIAL_ACCOUNTS_ROUTE_PATHS } from './config';

export const CREDENCIAL_ACCOUNTS_ROUTES: TApplicationRoute[] = [
  {
    id: 'treasury-credencial',
    path: CREDENCIAL_ACCOUNTS_ROUTE_PATHS.credencialAccounts,
    component: lazy(() => import('./pages/credencial-accounts-page')),
    layout: 'default',
    permissions: { scopes: ['treasury-credencial'] },
    menu: {
      title: 'pages.treasury.credencialAccounts.title',
    },
  },
];
